export interface IProveStartPayload {
  phoneNumber?: string;
  dob: string;
  flowType: string;
  finalTargetUrl?: string;
}

export interface IProveChallengeRequest {
  correlationId: string;
  dob?: string;
}

export interface IProveStartResponse {
  next: {
    [key: string]: string;
  };
  authToken: string;
  correlationId: string;
}

export interface IProveValidateResponse {
  next: {
    [key: string]: string;
  };
  phoneNumber: string;
  success: boolean;
  challengeMissing: boolean;
}

export interface IProveChallengeResponse {
  next: {
    [key: string]: string;
  };
  individual: {
    firstName: string;
    lastName: string;
    addresses: Address[];
    emailAddresses: string[];
    dob: string;
    ssn: string;
  };
  success: boolean;
}

export interface Address {
  address: string;
  city: string;
  extendedAddress: string | null;
  postalCode: string;
  region: string;
}

export interface IProveCompleteResponse {
  next: {
    [key: string]: string;
  };
  success: boolean;
}

export interface IUserInformationPayload {
  individual: {
    firstName: string;
    lastName: string;
    addresses: Address[];
    emailAddresses: string[];
    dob: string;
    ssn: string;
  };
  correlationId: string;
}

export enum Flowtype {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}

export interface Next {
  'v3-validate'?: string;
  'v3-challenge'?: string;
  'v3-complete'?: string;
  done?: string | null;
}

export interface IValidateRequestPayload {
  correlationId: string;
}
